<app-loading-generico
  [loadingGenerico]="loadingGenerico"
></app-loading-generico>
@if (showAlertAnotacoesOcorrencias) {
  <div class="body-alert">
    <div class="div-alert text-center">
      <div class="d-flex justify-content-end"></div>
      <div class="row mt-3">
        <div class="col-lg-12 text-start">
          <h1 class="titulo">Histórico de anotações</h1>
          <button
            id="botaoFecharModal"
            class="botaoFecharModal"
            (click)="abrirFechar()"
            >
            <svg
              width="24"
              height="24"
              viewBox="0 0 33 33"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M25.9507 7.06407C25.2348 6.34811 24.074 6.34811 23.358 7.06407L16.6542 13.7679L9.9505 7.06417C9.23454 6.34821 8.07373 6.34821 7.35777 7.06417C6.64181 7.78013 6.64181 8.94093 7.35777 9.65689L14.0615 16.3606L7.35797 23.0641C6.64201 23.7801 6.64201 24.9409 7.35797 25.6568C8.07393 26.3728 9.23474 26.3728 9.9507 25.6568L16.6542 18.9533L23.3578 25.6569C24.0738 26.3729 25.2346 26.3729 25.9505 25.6569C26.6665 24.941 26.6665 23.7802 25.9505 23.0642L19.2469 16.3606L25.9507 9.6568C26.6667 8.94083 26.6667 7.78003 25.9507 7.06407Z"
                fill="#878787"
                />
            </svg>
          </button>
          <div class="subtitulo">
            Aqui você encontra todas as anotações referêntes à esta ocorrência.
          </div>
        </div>
        @if (
          resources && resources.length > 0) {
          <div class="row" class="conteudo-historico">
            @for (d of resources; track d) {
              <div class="col-12">
                <div class="row">
                  <div class="col-lg-4">
                    <p class="texto-titulo text-start">Data</p>
                    <p class="subtitulo-alert text-start">
                      {{ $safeNavigationMigration(d?.data) | date : "dd/MM/yyy  H:mm" }}
                    </p>
                  </div>
                  <div class="col-lg-4">
                    <p class="texto-titulo text-start">Responsável</p>
                    <p class="subtitulo-alert text-start">{{ d?.responsavel }}</p>
                  </div>
                  @if (d.arquivos && d.arquivos.length > 0) {
                    <div
                      class="col-lg-4"
                      class="lista-arquivos"
                      >
                      <p class="texto-titulo text-start">Arquivo anexado</p>
                      @for (arquivo of d?.arquivos; track arquivo) {
                        <div>
                          <button
                            class="btn-icon text-start conteudo-arquivos"
                            (click)="baixarArquivo(arquivo.id, arquivo.nomeArquivo)"
                            >
                            <div style="margin-right: 4px">
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 33 33"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M4.65413 20.6238C5.39051 20.6238 5.98747 21.2207 5.98747 21.9571V24.6238C5.98747 26.0965 7.18138 27.2904 8.65413 27.2904H24.6541C26.1269 27.2904 27.3208 26.0965 27.3208 24.6238V21.9571C27.3208 21.2207 27.9178 20.6238 28.6541 20.6238C29.3905 20.6238 29.9875 21.2207 29.9875 21.9571V24.6238C29.9875 27.5693 27.5997 29.9571 24.6541 29.9571H8.65413C5.70862 29.9571 3.3208 27.5693 3.3208 24.6238V21.9571C3.3208 21.2207 3.91775 20.6238 4.65413 20.6238Z"
                                  fill="#008060"
                                  />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M16.6541 21.9572C15.9178 21.9572 15.3208 21.3602 15.3208 20.6238L15.3208 4.62382C15.3208 3.88744 15.9178 3.29049 16.6541 3.29049C17.3905 3.29049 17.9875 3.88744 17.9875 4.62382L17.9875 20.6238C17.9875 21.3602 17.3905 21.9572 16.6541 21.9572Z"
                                  fill="#008060"
                                  />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M9.04482 13.0143C8.52412 13.535 8.52412 14.3792 9.04482 14.8999L15.7115 21.5666C16.2322 22.0873 17.0764 22.0873 17.5971 21.5666L24.2638 14.8999C24.7845 14.3792 24.7845 13.535 24.2638 13.0143C23.7431 12.4936 22.8989 12.4936 22.3782 13.0143L16.6543 18.7382L10.9304 13.0143C10.4097 12.4936 9.56552 12.4936 9.04482 13.0143Z"
                                  fill="#008060"
                                  />
                              </svg>
                            </div>
                            <div class="nome-arquivo">
                              {{ arquivo.nomeArquivo | uppercase }}
                            </div>
                          </button>
                        </div>
                      }
                    </div>
                  }
                </div>
                <div class="row">
                  <div class="col-lg-12 text-start">
                    <p class="texto-titulo">Descrição</p>
                    <textarea
                      class="border-0"
                      rows="3"
                      cols="50"
                      id="detalhes"
                      readonly
                      >{{ d?.descricao }}</textarea
                      >
                    </div>
                  </div>
                </div>
              }
            </div>
            <hr />
          } @else {
            Nenhum histórico de anotações encontrado.
          }
        </div>
        <div class="row w-100">
          <div class="footer-historico">
            <button
              class="btn botao-outline botao-voltar" style="margin-right: 40px;"
              (click)="fecharHistoricoAnotacoesOcorrencias()"
              >
              FECHAR
            </button>
          </div>
        </div>
      </div>
    </div>
  }
